import { DataModel } from 'legacy/lut/classes/models/DataModel'
import { IBusinessProfileIcon } from 'legacy/lut/classes/services/api/BusinessProfileApi'
import businessProfileStoreService from 'legacy/lut/classes/services/BusinessProfileStoreService'
import React from 'react'

import { IForm } from 'core-components/classes/models/IForm'

import styles from '../ContactTileCell.module.scss'

export const renderCardStatusLine = (item: DataModel | IForm) => {
  return (
    <div
      className={styles.statusLine}
      style={{
        backgroundColor: getWorkflowStatusColor(item.get('WorkflowStatus') || ''),
      }}
    />
  )
}

export const getWorkflowStatusColor = (workflowStatus: string) => {
  switch (workflowStatus) {
    case 'New':
      return '#cccc00'
    case 'WIP':
      return '#FFA500'
    case 'Rejected':
      return '#ff0000'
    default:
      return '#ffffff'
  }
}

export const getCountEmptyFields = (item: DataModel | IForm) => {
  const result: any = []
  const { modifiedFieldsExt } = businessProfileStoreService

  modifiedFieldsExt.forEach((row) => {
    if (!item.rawData[row]) {
      result.push(row)
    }
    return
  })

  if (!result.length) {
    return 'All field are completed'
  }
  return `Add information to fields: ${result.join(', ')}`
}

export const getPhone = (item: DataModel | IForm) => {
  if ((item.get('WorkPhone') || '').length) {
    return `${item.get('WorkPhone_Prefix') || ''}${item.get('WorkPhone') || ''}`
  }
  if ((item.get('MobilePhone') || '').length) {
    return `${item.get('MobilePhone_Prefix') || ''}${item.get('MobilePhone') || ''}`
  }
  return item.get('MainPhone') || ''
}

export const getIcon = (array: IBusinessProfileIcon[], iconId: string) => {
  return array.find((item) => item.Id === iconId) || array.find((item) => item.Default === true)
}

export const getCompetitors = (item: DataModel | IForm) => {
  const result = JSON.parse(item.get('Competitors') || '[]')
  if (!result.length) {
    return 'No competitors'
  }
  return `Сompetitors: ${result.join(', ')}`
}
